import { useState } from 'react'
import { postDate } from '../apiCalls'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'

const NewDate = (props) => {
    const getDates = props.mods.getDates
    const setDateFormToggle = props.mods.setDateFormToggle

    const [dateForm, setDateForm] = useState({
        name: "",
        date: "",
        time: "",
        details: "",
        dateName: "",
        dateImage: "",
        location: ""
    })

    const handleChange = (e) => {
        setDateForm((baseState) => ({
            ...baseState,
            [e.target.name]: e.target.value
        }))
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault()
            await postDate(dateForm)
            e.target.reset();
            getDates()

        } catch(err) {
            console.log(err)
        }
    }

    function handleClose() {
        setDateFormToggle(false)
    }

    return (
        <div className="newDateContainer">
            <i className="bi bi-x-square closeIcon" onClick={handleClose}></i>
            <Container>
                <h2 className="">New Date</h2>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group className="sm-2" controlId="newDateName">
                                <Form.Label>Name: </Form.Label>
                                <Form.Control type='text' name="name" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateDate">
                                <Form.Label>Date: </Form.Label>
                                <Form.Control type='date' name="date" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateTime">
                                <Form.Label>Time: </Form.Label>
                                <Form.Control type='time' name="time" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateLocation">
                                <Form.Label>Location: </Form.Label>
                                <Form.Control type='text' name="location" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateDetails">
                                <Form.Label>Details: </Form.Label>
                                <Form.Control type='text' name="details" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateDateName">
                                <Form.Label>Date's Name: </Form.Label>
                                <Form.Control type='text' name="dateName" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateDateImage">
                                <Form.Label>Date's Photo: </Form.Label>
                                <Form.Control type='text' name="dateImage" onChange={handleChange}></Form.Control>
                            </Form.Group>
                        </Row>
                        <Row className="inputButtonRow mt-2">
                            <Col className="d-flex justify-content-center">
                                <Button variant="dark" type="submit" className="defaultButton">Schedule Date</Button>
                            </Col>
                        </Row>
                    </Form>
            </Container>
        </div>
    )
}

export default NewDate